import { createSlice } from '@reduxjs/toolkit';
import { getCurrentUser } from '../thunks/user';

export const usersSlice = createSlice({
  name: 'user',
  initialState: null,
  reducers: {
    setUser: (_state, action) => action.payload,
    removeUser: () => null,
  },
  extraReducers: (builder) => {
    builder.addCase(getCurrentUser.rejected, () => null);
  },
});

export const { removeUser, setUser } = usersSlice.actions;
export default usersSlice.reducer;
